module.exports = __webpack_public_path__ + "img/roadmap.bfc2b320.jpg";